import { render, staticRenderFns } from "./EnviarPrueba.vue?vue&type=template&id=6acc20d7"
import script from "./EnviarPrueba.vue?vue&type=script&lang=js"
export * from "./EnviarPrueba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports